import { InternalLinkButton } from '@aibees/shared/components';
import { Stack } from '@mui/material';
import { styled } from '@mui/material/styles';

export const Wrapper = styled(Stack)``;

export const Link = styled(InternalLinkButton)`
  overflow: hidden;
`;
